import * as React from "react";
import ViewportImage from "../ViewportImage";
import { AI_REGION_COLOR } from "../Viewport";
import LocalStorageService from "../../../service/LocalStorageService";
import { AiPass } from "../../../api/StudyApi";
import { UncontrolledTooltip } from "reactstrap";
import classNames from "classnames";

function getColor(aiPass: AiPass) {
  let color = AI_REGION_COLOR;
  const ot = LocalStorageService.getObservationType(aiPass.type);

  if (ot && ot.color) {
    color = ot.color;
  }
  return color;
}

type TooltipProps = {
  viewportImage: ViewportImage;
  aiPass: AiPass;
};

function AiRegionTooltip({ viewportImage, aiPass }: TooltipProps) {
  const passColor = getColor(aiPass);
  const tooltipId = `aiModelHash${viewportImage.image.id}${aiPass.type}`;

  const hasRegions = aiPass.aiRegions.length > 0;
  const style = hasRegions
    ? { backgroundColor: passColor }
    : {
        borderColor: passColor,
        color: passColor,
      };

  return (
    <div className={classNames(hasRegions ? "mg-ai-pass-with-regions" : "img-ai-pass-no-region")} style={style}>
      <span data-href="#" id={tooltipId}>
        AI
      </span>
      <UncontrolledTooltip placement="bottom" autohide={false} target={tooltipId}>
        {aiPass.modelHash} - {aiPass.type} {hasRegions && `(${aiPass.aiRegions.length})`}
      </UncontrolledTooltip>
    </div>
  );
}

type AiPassBadgesProps = {
  viewportImage: ViewportImage;
  displayAiBadge: boolean;
};

function AiPassBadges({ viewportImage, displayAiBadge }: AiPassBadgesProps) {
  return (
    <div className="img-ai-pass-wrapper">
      {displayAiBadge &&
        viewportImage.aiPasses.map((aiPass, index) => (
          <AiRegionTooltip viewportImage={viewportImage} aiPass={aiPass} key={index} />
        ))}
    </div>
  );
}

export default AiPassBadges;
